import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api, errorMessage } from "@/lib/api";
import { PricingSection } from "@/components/settings/PricingSection";
import { ProductLinesSection } from "@/components/settings/ProductLinesSection";
import { ShapesSection } from "@/components/settings/ShapesSection";
import { CatalogSection } from "@/components/settings/CatalogSection";
import { MarkupPresetsSection } from "@/components/settings/MarkupPresetsSection";
import { GlassBandsSection } from "@/components/products/GlassBandsSection";
import { DefaultGlassSection, LearnedMatchesSection } from "@/components/products/LearnedMatches";
import { BuilderPricesSection } from "@/components/products/BuilderPrices";
import { ExtrasLibrarySection } from "@/components/products/ExtrasLibrarySection";
import { CatalogProductsEditor } from "@/components/products/CatalogProductsEditor";
import { BackupSection, PricingLogSection } from "@/components/products/LogBackup";

const TABS = [["types", "Types & product lines"], ["glass", "Glass"], ["extras", "Extras"], ["builder", "Builder options"], ["shapes", "Shapes"], ["catalog", "Catalog"],
  ["learned", "Learned matches"], ["markup", "Markup"], ["log", "Change log"], ["backup", "Backup"]];

export default function Products() {
  const [settings, setSettings] = useState(null);
  const [tab, setTab] = useState("types");
  const load = () => api.get("/settings").then((r) => setSettings(r.data)).catch((e) => toast.error(errorMessage(e)));
  useEffect(() => { load(); }, []);
  const setCompany = (company) => setSettings((s) => ({ ...s, company }));
  return (
    <div className="space-y-8" data-testid="products-page">
      <div className="rise">
        <h1 className="font-display text-4xl font-extrabold tracking-tight text-slate-50 sm:text-5xl">Products & pricing</h1>
        <p className="mt-2 text-sm text-slate-400">Every window and door type, its product lines and every rate. New prices apply at once. Saved estimates keep their prices, and Drafts change only on Reprice.</p>
      </div>
      {!settings ? <div className="h-96 animate-pulse rounded-2xl bg-slate-900/50" /> : (
        <Tabs value={tab} onValueChange={setTab} className="rise rise-1">
          <TabsList className="flex h-auto w-full flex-wrap justify-start gap-0.5 sm:w-auto">
            {TABS.map(([k, l]) => (
              <TabsTrigger key={k} value={k} data-testid={`products-tab-${k}`} className="min-h-[32px] px-3.5 text-[13px]">{l}</TabsTrigger>
            ))}
          </TabsList>
          <TabsContent value="types" className="mt-6 space-y-8">
            <PricingSection settings={settings} onSaved={setSettings} />
            <ProductLinesSection types={settings.types || []} onTypesChanged={load} company={settings.company} onCompany={setCompany} />
          </TabsContent>
          <TabsContent value="glass" className="mt-6 space-y-8"><DefaultGlassSection /><GlassBandsSection /></TabsContent>
          <TabsContent value="learned" className="mt-6"><LearnedMatchesSection /></TabsContent>
          <TabsContent value="builder" className="mt-6"><BuilderPricesSection /></TabsContent>
          <TabsContent value="extras" className="mt-6"><ExtrasLibrarySection /></TabsContent>
          <TabsContent value="shapes" className="mt-6"><ShapesSection types={settings.types || []} /></TabsContent>
          <TabsContent value="catalog" className="mt-6 space-y-8"><CatalogProductsEditor /><CatalogSection /></TabsContent>
          <TabsContent value="markup" className="mt-6"><MarkupPresetsSection /></TabsContent>
          <TabsContent value="log" className="mt-6"><PricingLogSection /></TabsContent>
          <TabsContent value="backup" className="mt-6"><BackupSection /></TabsContent>
        </Tabs>
      )}
    </div>
  );
}
